<div class="d-flex align-items-start justify-content-center px-4 px-md-6 py-md-6">
  <div class="flex-1 d-flex justify-content-center">
    <img
      src="/assets/images/3d-shield-white.webp"
      alt="3d-shield-white"
      width="200"
      height="200"
      class="image"
    />
  </div>

  <ds-button
    (click)="hideModal.emit()"
    variant="icon"
    size="s"
    icon="xmark"
    label="Close"
    class="d-none d-md-inline ml-auto"
    data-id="hide"
  />
</div>

@let discount = (ancillaryBundle?.discount || 0) * 100;

<div class="d-flex flex-column px-4 px-md-6 mt-4 mt-md-0">
  <h1 class="semi-bold">Your trip isn’t fully protected yet</h1>

  <p class="mt-3">Cancel For Any Reason covers your plans — but not airline<br />disruptions.</p>

  <div class="d-flex flex-column g-6 mt-6">
    @for (section of sections; track section) {
      <div class="d-flex flex-1 flex-column g-3">
        <p class="semi-bold">{{ section.title }}</p>

        @for (item of section.items; track item) {
          <div class="d-flex g-2">
            <img
              src="/assets/icons/{{ item.icon }}.svg"
              alt="{{ item.icon }}"
              width="20"
              height="20"
            />

            <p>{{ item.label }}</p>
          </div>
        }
      </div>
    }
  </div>

  <p class="semi-bold mt-6 text-green-750">Upgrade to bundle & save {{ discount }}% instantly</p>
</div>

<div class="d-flex flex-column px-4 px-md-6 my-4 my-md-6 g-2">
  @let pricePerTraveler = disruptionProtectionAncillary?.pricePerTraveler || 0;
  @let priceWithoutDiscountPerTraveler =
    disruptionProtectionAncillary?.priceWithoutDiscountPerTraveler || 0;

  <hr />

  <p class="caption">
    Add Premium Disruption Protection to get {{ discount }}% off your Full Peace bundle. This price
    is unlocked with Cancel For Any Reason.
  </p>

  <ds-button
    (click)="upsellDisruptionProtectionContinue.emit()"
    [label]="
      'Complete your protection for ' +
      (pricePerTraveler | portalCurrency) +
      ' ' +
      (priceWithoutDiscountPerTraveler | portalCurrency)
    "
    data-id="add"
  />

  <ds-button
    (click)="upsellDisruptionProtectionNext.emit()"
    variant="secondary"
    label="No, I’ll take the risk"
    data-id="no"
  />
</div>
